import Helper from '@ember/component/helper';

const UNITS = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export function formatBytes([bytes]: [number | null | undefined]) {
  let index = 0;
  let convertedBytes = bytes ?? 0;

  if (convertedBytes === 1) {
    return '1 byte';
  }

  while (convertedBytes >= 1024 && ++index) {
    convertedBytes = convertedBytes / 1024;
  }

  let result = convertedBytes.toFixed(convertedBytes < 10 && index > 0 ? 1 : 0);
  if (result.endsWith('.0')) {
    result = result.slice(0, -2);
  }

  return `${result} ${UNITS[index]}`;
}

/*
  Basic Usage:

  ```handlebars
  {{format-bytes count}}
  ```
*/
export default Helper.helper(formatBytes);
